const SITE_URL = 'https://www.xn--marchdz-fya.com';
const SITE_NAME = 'Marché DZ';
const LOGO_URL = `${SITE_URL}/icons/icon-512.png`;

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: LOGO_URL,
  description: 'أكبر سوق إلكتروني في الجزائر - تسوق أونلاين بأفضل الأسعار مع توصيل سريع لجميع الولايات',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'DZ',
  },
  sameAs: [],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.url}`,
  })),
});

export const productSchema = (product: {
  name: string;
  description?: string;
  price: number;
  image?: string;
  url: string;
  rating?: number;
  reviewCount?: number;
  storeName?: string;
  inStock?: boolean;
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: product.name,
  description: product.description || product.name,
  image: product.image || LOGO_URL,
  url: `${SITE_URL}${product.url}`,
  brand: {
    '@type': 'Brand',
    name: product.storeName || SITE_NAME,
  },
  offers: {
    '@type': 'Offer',
    price: product.price,
    priceCurrency: 'DZD',
    availability: product.inStock !== false
      ? 'https://schema.org/InStock'
      : 'https://schema.org/OutOfStock',
    seller: {
      '@type': 'Organization',
      name: product.storeName || SITE_NAME,
    },
  },
  ...(product.rating && product.reviewCount ? {
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: product.rating,
      reviewCount: product.reviewCount,
      bestRating: 5,
    },
  } : {}),
});

export const localBusinessSchema = (store: {
  name: string;
  description?: string;
  image?: string;
  url: string;
  phone?: string;
  address?: string;
  rating?: number;
  reviewCount?: number;
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Store',
  name: store.name,
  description: store.description || store.name,
  image: store.image || LOGO_URL,
  url: `${SITE_URL}${store.url}`,
  telephone: store.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: store.address,
    addressCountry: 'DZ',
  },
  ...(store.rating && store.reviewCount ? {
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: store.rating,
      reviewCount: store.reviewCount,
      bestRating: 5,
    },
  } : {}),
});

export const restaurantSchema = (restaurant: {
  name: string;
  description?: string;
  image?: string;
  url: string;
  phone?: string;
  address?: string;
  cuisineType?: string;
  rating?: number;
  reviewCount?: number;
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Restaurant',
  name: restaurant.name,
  description: restaurant.description || restaurant.name,
  image: restaurant.image || LOGO_URL,
  url: `${SITE_URL}${restaurant.url}`,
  telephone: restaurant.phone,
  servesCuisine: restaurant.cuisineType,
  address: {
    '@type': 'PostalAddress',
    streetAddress: restaurant.address,
    addressCountry: 'DZ',
  },
  ...(restaurant.rating && restaurant.reviewCount ? {
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: restaurant.rating,
      reviewCount: restaurant.reviewCount,
      bestRating: 5,
    },
  } : {}),
});
